/*
 *
 * OperationDCC
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 10-Mar-2025
 */
import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  transactionDCCId: (
    <PortalMessage id='t.app.orders.operation.dcc.transactionDCCId' defaultMessage='Transaction DCC Id' />
  ),
  rrID: <PortalMessage id='t.app.orders.operation.dcc.rrID' defaultMessage='Rate Request Reference ID' />,
  merchantAmount: <PortalMessage id='t.app.orders.operation.dcc.merchantAmount' defaultMessage='Merchant Amount' />,
  merchantCurrency: (
    <PortalMessage id='t.app.orders.operation.dcc.merchantCurrency' defaultMessage='Merchant Currency' />
  ),
  merchantCurrencyCode: (
    <PortalMessage id='t.app.orders.operation.dcc.merchantCurrencyCode' defaultMessage='Merchant Currency Code' />
  ),
  operationAmount: (
    <PortalMessage id='t.app.orders.operation.dcc.operationAmount' defaultMessage='Cardholder Amount' />
  ),
  operationCurrency: (
    <PortalMessage id='t.app.orders.operation.dcc.operationCurrency' defaultMessage='Cardholder Currency' />
  ),
  cardholderCurrencyCode: (
    <PortalMessage id='t.app.orders.operation.dcc.cardholderCurrencyCode' defaultMessage='Cardholder Currency Code' />
  ),
  conversionRate: <PortalMessage id='t.app.orders.operation.dcc.conversionRate' defaultMessage='Conversion Rate' />,
  markup: <PortalMessage id='t.app.orders.operation.dcc.markup' defaultMessage='Markup' />,
  markupIncludesECB: (
    <PortalMessage id='t.app.orders.operation.dcc.markupIncludesECB' defaultMessage='Markup Includes ECB' />
  ),
  outcome: <PortalMessage id='t.app.orders.operation.dcc.outcome' defaultMessage='Outcome' />
}

export default formattedMessage
